var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-container"},[_c('img',{staticClass:"profile-img-card",attrs:{"id":"profile-img","src":"//ssl.gstatic.com/accounts/ui/avatar_2x.png"}}),_c('div',{staticClass:"text-center alert alert-success"},[_vm._v(" در حال خروج... ")])])])
}]

export { render, staticRenderFns }